.sidebar {
    position: sticky;
    top: 56px;
    border-right: 1px solid #dee2e6;
    background: white;
    padding: 1rem 0;

    details [class*='bi-'] {
        transition: 0.25s;
    }
    details[open] [class*='bi-chevron'] {
        transform: rotate(180deg);
    }
}

.navLink {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s;
    cursor: pointer;
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    color: #495057 !important;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
        background-color: #e9ecef;
        color: #0d6efd !important;
    }
    &.active {
        border-left-color: #0d6efd;
        background-color: #e7f1ff;
        color: #0d6efd !important;
        font-weight: 600;
    }
}
